import React from 'react';
import { CheckCircleIcon, TrendingUpIcon, ShieldIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-gray-100" data-id="element-188">
      <div className="container mx-auto px-4" data-id="element-189">
        <div className="max-w-4xl mx-auto" data-id="element-190">
          <div className="flex justify-center mb-8" data-id="element-191">
            <TrendingUpIcon className="text-red-600" size={64} data-id="element-192" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-193">
            WHY CHOOSE 247ALPHA
          </h2>
          <p className="text-center mb-12 text-lg" data-id="element-194">
            247Alpha stands apart from other testosterone supplements on the
            market:
          </p>
          <div className="space-y-8" data-id="element-195">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-196">
              <div className="flex items-start" data-id="element-197">
                <CheckCircleIcon className="text-red-600 mr-3 mt-1" size={24} data-id="element-198" />
                <div data-id="element-199">
                  <h3 className="text-xl font-bold mb-3" data-id="element-200">
                    Premium Quality Ingredients
                  </h3>
                  <p data-id="element-201">
                    Every ingredient in 247Alpha is sourced from its native
                    region and standardized to the exact potency used in
                    clinical studies.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-202">
              <div className="flex items-start" data-id="element-203">
                <CheckCircleIcon className="text-red-600 mr-3 mt-1" size={24} data-id="element-204" />
                <div data-id="element-205">
                  <h3 className="text-xl font-bold mb-3" data-id="element-206">
                    Transparent Formula
                  </h3>
                  <p data-id="element-207">
                    Unlike competitors who hide behind "proprietary blends," we
                    disclose every ingredient and its exact dosage so you know
                    exactly what you're getting.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-208">
              <div className="flex items-start" data-id="element-209">
                <CheckCircleIcon className="text-red-600 mr-3 mt-1" size={24} data-id="element-210" />
                <div data-id="element-211">
                  <h3 className="text-xl font-bold mb-3" data-id="element-212">
                    Pharmaceutical-Grade Manufacturing
                  </h3>
                  <p data-id="element-213">
                    247Alpha is produced in an FDA-registered facility that
                    adheres to strict Good Manufacturing Practices (GMP) to
                    ensure purity and potency.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}